export const items = [
  [
    {
      name: 'Blog',
      icon: '/CloudUpload.svg',
      link: '/blog'
    },
    {
        name: 'Competitor Comparisons',
        icon: '/Reports.svg',
        link: '/competitor-comparisons/'
    },
    {
      name: 'Content Library',
      icon: '/UserActivity.svg',
      link: '/resources/'
    },
    {
      name: 'Legal',
      icon: '/Reports.svg',
      link: '/legal/'
    }
  ]
];

export const label = 'Resources';
